import { render, staticRenderFns } from "./WhatsappCampanhaEdit.vue?vue&type=template&id=d5aaffcc"
import script from "./WhatsappCampanhaEdit.vue?vue&type=script&lang=js"
export * from "./WhatsappCampanhaEdit.vue?vue&type=script&lang=js"
import style0 from "./WhatsappCampanhaEdit.vue?vue&type=style&index=0&id=d5aaffcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports